/*
  PDP sticky bar — visibility toggle + back-to-top action.

  Hidden by default. Becomes visible once the product's media area
  (.product__main, which holds the image gallery) has scrolled
  entirely above the top of the viewport. Hidden again when the user
  scrolls back up past the gallery.

  Inspired by TPC's `product-sticky-bar-always.js` (uses an
  IntersectionObserver on the inline form to decide visibility), but
  adapted here to observe the GALLERY's position instead — the user
  has explicitly asked for "once past the product image, the banner
  appears." Watching the gallery means the bar shows whenever the
  product image is no longer visible, regardless of how the rest of
  the info column is laid out.

  The back-to-top button smoothly scrolls the page to the top of the
  product gallery (not the document top — keeps the user oriented to
  the PDP rather than dumping them at the site header).
*/
(function () {
  function init() {
    document.querySelectorAll('[data-pdp-sticky-bar]').forEach(setupBar);
  }

  function setupBar(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    if (!sectionId) return;

    // Find the product gallery (.product__main inside the section the
    // sticky bar belongs to). Used both to decide visibility and as
    // the scroll target for the back-to-top button.
    var section = document.getElementById('MainProduct-' + sectionId);
    var gallery = section && section.querySelector('.product__main');
    if (!gallery) return;

    var galleryAbove = false;
    var footerVisible = false;

    /* Observe the gallery's bounding rect. When it has scrolled fully
       above the viewport (bottom edge < 0), show the bar. While the
       gallery is at all visible, hide the bar. */
    var galleryObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          galleryAbove = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        }
        applyVisibility();
      },
      { threshold: 0 }
    );
    galleryObserver.observe(gallery);

    /* Observe the site footer. Once the user has scrolled the
       footer substantially into the viewport we hide the sticky bar.
       The negative bottom rootMargin (-50%) means the observer
       waits until roughly half the viewport is below the top of
       the footer before it triggers — so the bar stays visible
       through the bulk of the page content + the start of the
       footer, and only fades out once the user has clearly arrived
       at the footer block. Fall back gracefully if no footer is
       found. */
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    if (footer) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            footerVisible = entries[i].isIntersecting;
          }
          applyVisibility();
        },
        { threshold: 0, rootMargin: '0px 0px -50% 0px' }
      );
      footerObserver.observe(footer);
    }

    function applyVisibility() {
      var shouldShow = galleryAbove && !footerVisible;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    /* Back to top — smooth-scrolls to the gallery's top edge, leaving
       a small offset below the sticky site header so the gallery isn't
       hidden underneath it on landing. */
    var btn = bar.querySelector('[data-pdp-sticky-back-to-top]');
    if (btn) {
      btn.addEventListener('click', function () {
        var headerHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        ) || 60;
        var targetY = window.scrollY + gallery.getBoundingClientRect().top - headerHeight;
        window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
